import type { WholesaleAccount } from "@/hooks/useWholesaleAccount";

export interface EffectivePrice {
  /** Final price the buyer pays, in cents. */
  priceCents: number;
  /** Original retail price, in cents (before any wholesale discount). */
  retailCents: number;
  /** True when a wholesale discount is applied. */
  isWholesale: boolean;
  /** Discount percent applied (0–80), 0 when retail. */
  discountPercent: number;
}

export const getEffectivePrice = (
  retailCents: number,
  account?: WholesaleAccount | null,
): EffectivePrice => {
  if (account && account.active && account.discount_percent > 0) {
    const discount = Math.min(80, Math.max(0, account.discount_percent));
    const priceCents = Math.round(retailCents * (1 - discount / 100));
    return {
      priceCents,
      retailCents,
      isWholesale: true,
      discountPercent: discount,
    };
  }
  return {
    priceCents: retailCents,
    retailCents,
    isWholesale: false,
    discountPercent: 0,
  };
};

export const tierLabel = (tier?: string | null) => {
  switch (tier) {
    case "gold":
      return "Gold";
    case "silver":
      return "Silver";
    default:
      return "Bronze";
  }
};
